import { DirectorMessage } from "./DirectorMessage";

export default DirectorMessage;
